import type { AgentClient } from "./AgentClient";
import {
  trackAgentCreated,
  trackAgentUpdated,
  trackAgentDeleted,
} from "../analytics/tracking";

/* Wraps an AgentClient so agent lifecycle analytics fire at the client layer —
 * every caller (the editor's create/update, the delete row) is covered in one
 * place, and events fire only after the mutation resolves. Read-only methods
 * pass straight through. */
export function withAgentTracking(client: AgentClient): AgentClient {
  return {
    list: () => client.list(),
    get: (agentId) => client.get(agentId),
    listOptimizations: (agentId) => client.listOptimizations(agentId),

    async create(payload) {
      const agent = await client.create(payload);
      trackAgentCreated(agent.agent_id, agent.kind);
      return agent;
    },

    async update(agentId, payload) {
      const agent = await client.update(agentId, payload);
      trackAgentUpdated(agent.agent_id, agent.kind, agent.enabled);
      return agent;
    },

    async remove(agentId) {
      await client.remove(agentId);
      trackAgentDeleted(agentId);
    },
  };
}
